export const NA = 'N/A';
export const TV = 'TV';
